// Register.jsx
import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";

export default function Register({ onRegistered }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  async function handleRegister(e) {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      onRegistered(userCredential.user);
    } catch (err) {
      setError("Kunne ikke oprette konto. Tjek email-format og adgangskode.");
    }
  }

  return (
	<div
      style={{
        position: "fixed",
        inset: 0,
        backgroundImage: 'url("https://bornholm-golf.dk/derby/static/startbillede.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
		alignItems: "center",
        color: "#fff",
        textShadow: "0 2px 6px rgba(0,0,0,0.6)",
        zIndex: 9999
      }}
    >
	<div
        style={{
          backgroundColor: "rgba(219, 245, 215, 0.80)",
          border: "3px solid #7AAD08",
          borderRadius: "16px",
          padding: "40px 60px",
          textAlign: "center",
          maxWidth: "1000px",
          color: "#2e3d2f",
          boxShadow: "0 8px 20px rgba(0,0,0,0.55)"
        }}
      >

      <h2>🏆 DERBY - Hestevæddeløb på Nordskovens Galopbane med præmier og spænding 🏆<br/>
	  
      📝 Opret en DERBY-konto</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={handleRegister}>
        <input
          type="text"
          placeholder="Dit navn"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ fontSize: "20px", margin: "10px" }}
        />
        <br />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ fontSize: "20px", margin: "10px" }}
        />
        <br />

        <input
          type="password"
          placeholder="Adgangskode"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ fontSize: "20px", margin: "10px" }}
        />
        <br />

        <button type="submit" style={{ fontSize: "22px", padding: "10px 20px" }}>
          Opret konto
        </button>
      </form>

      <p style={{ marginTop: "10px" }}>
        Allerede bruger?  
        <button onClick={() => onRegistered("login")} style={{ fontSize: "18px" }}>
          Log ind
        </button>
      </p>
    </div>
	</div>
  );
}